import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Body, Footer, Header, Popup } from '@calendly/ui/components/popup'

// Same CUI Popup shell as LeaveEditorConfirmationPopup/UpdatePageLanguageConfirmationPopup.
// Guards the kebab's "Delete" item; the event type name renders as the header's subtitle
// instead of being interpolated into the title, matching current design.
export const DeleteEventTypeConfirmationPopup = ({ isOpen, name, isDeleting, onClose, onConfirm }) => (
  <Popup isOpen={isOpen} onClose={onClose} size="small" withCloseButton>
    <Header
      title={I18n.t('publisher.event_type_editor_crud.header.delete_confirmation.title')}
      subtitle={name}
    />
    <Body>
      {I18n.t('publisher.event_type_editor_crud.header.delete_confirmation.body')}
    </Body>
    <Footer isOffset>
      <Button
        appearance="secondary-outline"
        size="medium"
        label={I18n.t('publisher.action.cancel')}
        onClick={onClose}
        data-testid="editor-delete-confirmation-cancel"
      />
      <Button
        appearance="danger"
        size="medium"
        label={I18n.t('publisher.action.delete')}
        loading={isDeleting}
        onClick={onConfirm}
        data-testid="editor-delete-confirmation-delete"
      />
    </Footer>
  </Popup>
)
